import React from "react";

import AvatarInput from "./AvatarInput";
import Checkbox from "./Checkbox";
import ColorPickerInput from "./Colorpicker";
import MultiTagInput from "./MultiTagInput";
import PasswordInput from "./PasswordInput";
import ReadOnlyInput from "./ReadOnlyInput";
import Switch from "./Switch";
import TextInput from "./TextInput";
import TextInputInline from "./TextInputInline";
import TextInputWithMask from "./TextInputWithMask";

import type { JSX } from "react";

import type { InputProps } from "./types";

export default function Input({
  icon,
  name,
  label,
  sublabel,
  type = "text",
  isRequired = false,
  isReadOnly = false,
  minLength = 0,
  min,
  defaultValue,
  isCompact,
  isFullWidth,
  value,
  className,
  control,
  errorMessage,
  isNoWrap,
  validate,
  onBlurCustom,
  isTooltipErrorMessage,
  mask,
  blocks,
  placeholder,
  size,
  isReversed,
  prefix,
  hasCopyToClipboard = false,
  normalize,
}: InputProps): JSX.Element {
  switch (type) {
    case "readOnly":
      return (
        <ReadOnlyInput
          className={className}
          icon={icon}
          isCompact={isCompact}
          isNoWrap={isNoWrap}
          isRequired={isRequired}
          label={label}
          name={name}
          sublabel={sublabel}
          type={type}
          value={value}
        />
      );
    case "color":
      return (
        <ColorPickerInput
          className={className}
          defaultValue={defaultValue}
          isCompact={isCompact}
          isFullWidth={isFullWidth}
          isNoWrap={isNoWrap}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
          label={label}
          name={name}
          sublabel={sublabel}
        />
      );
    case "switch":
      return (
        <Switch
          className={className}
          defaultValue={defaultValue}
          isCompact={isCompact}
          isNoWrap={isNoWrap}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
          isReversed={isReversed}
          label={label}
          name={name}
          size={size}
          sublabel={sublabel}
        />
      );
    case "checkbox":
      return (
        <Checkbox
          className={className}
          defaultValue={defaultValue}
          isCompact={isCompact}
          isNoWrap={isNoWrap}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
          label={label}
          name={name}
          sublabel={sublabel}
        />
      );
    case "inline-text":
      return (
        <TextInputInline
          className={className}
          control={control}
          defaultValue={defaultValue}
          errorMessage={errorMessage}
          isRequired={isRequired}
          name={name}
        />
      );
    case "password":
      return (
        <PasswordInput
          className={className}
          icon={icon}
          isCompact={isCompact}
          isFullWidth={isFullWidth}
          isNoWrap={isNoWrap}
          isRequired={isRequired}
          isTooltipErrorMessage={isTooltipErrorMessage}
          label={label}
          minLength={minLength}
          name={name}
          onBlurCustom={onBlurCustom}
          sublabel={sublabel}
          validate={validate}
        />
      );
    case "avatar":
      return (
        <AvatarInput
          className={className}
          defaultValue={defaultValue}
          name={name}
        />
      );
    case "multiTag":
      return (
        <MultiTagInput
          className={className}
          defaultValue={defaultValue}
          icon={icon}
          isCompact={isCompact}
          isNoWrap={isNoWrap}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
          isTooltipErrorMessage={isTooltipErrorMessage}
          label={label}
          name={name}
          placeholder={placeholder}
          sublabel={sublabel}
          validate={validate}
        />
      );
    case "text":
    case "number":
    default:
      if (mask) {
        return (
          <TextInputWithMask
            blocks={blocks}
            className={className}
            defaultValue={defaultValue}
            icon={icon}
            isCompact={isCompact}
            isNoWrap={isNoWrap}
            isReadOnly={isReadOnly}
            isRequired={isRequired}
            isTooltipErrorMessage={isTooltipErrorMessage}
            label={label}
            mask={mask}
            name={name}
            onBlurCustom={onBlurCustom}
            placeholder={placeholder}
            sublabel={sublabel}
            type={type}
            validate={validate}
          />
        );
      }

      return (
        <TextInput
          className={className}
          defaultValue={defaultValue}
          hasCopyToClipboard={hasCopyToClipboard}
          icon={icon}
          isCompact={isCompact}
          isFullWidth={isFullWidth}
          isNoWrap={isNoWrap}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
          isTooltipErrorMessage={isTooltipErrorMessage}
          label={label}
          min={min}
          minLength={minLength}
          name={name}
          normalize={normalize}
          onBlurCustom={onBlurCustom}
          placeholder={placeholder}
          prefix={prefix}
          sublabel={sublabel}
          type={type}
          validate={validate}
        />
      );
  }
}
